import { PayloadAction } from '@reduxjs/toolkit'

import { GetAccountsResponse } from '../api/types'

import { StateType } from './initialState'

export const GetAccountsReducer = {
  pending: (state: StateType) => ({
    ...state,
    loading: 'pending',
  }),
  fulfilled: (state: StateType, action: PayloadAction<GetAccountsResponse>) => ({
    ...state,
    list: action.payload.data.data,
    pagination: { ...state.pagination, ...action.payload.data.meta },
    loading: 'succeeded',
  }),
  rejected: (state: StateType) => ({
    ...state,
    loading: 'failed',
  }),
}

// export const SetAccountCfdStatusReducer = {
//   pending: (state: StateType) => ({
//     ...state,
//     loading: 'pending',
//   }),

//   fulfilled: (state: StateType, action: PayloadAction<SetCfdStatusResponse>) => {
//     const { id: accountId, isCfd } = action.payload.data
//     const excludeCfdActive = state.pagination.filters.includes(AccountFiltersEnum.excludeCfd)

//     // update in place (Immer handles immutability)
//     const account = state.list.find((acc) => acc.id === accountId)
//     if (account) {
//       account.isCfd = isCfd
//     }

//     // if excludeCfd filter is active and account is CFD → remove it from visible list
//     if (excludeCfdActive && isCfd) {
//       state.list = state.list.filter((acc) => acc.id !== accountId)
//     }

//     state.loading = 'succeeded'
//   },

//   rejected: (state: StateType) => ({
//     ...state,
//     loading: 'failed',
//   }),
// }
